<template>
  <div id="QuestionsLayout" class="pageWrapper">
    <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>